<template lang="pug">
div(
    :class="styles.root"
)
    Card(
        :class="[styles.top, styles.card, 'skeleton-animation']"
        radius="m"
        radius-side="all"
    )
        div(
            :class="[styles.logo]"
        )
        div(
            :class="[styles.skeleton, styles.label]"
        )
        div(
            :class="[styles.skeleton , styles.amount]"
        )
        div(
            :class="[styles.skeleton, styles.timer]"
        )
    Card(
        :class="[styles.card, 'skeleton-animation']"
        radius="m"
        radius-side="all"
    )
        div(
            :class="[styles.tabs]"
        )
        div(
            :class="[styles.skeleton,styles.title, styles['title-top']]"
        )
        div(
            :class="[styles.skeleton,styles.title, styles['title-bottom']]"
        )
        div(
            :class="styles.list"
        )
            BankCellSkeleton(
                v-for="i in 20"
                :key="i"
            )
</template>

<script lang="ts">
import Vue, { useCssModule } from 'vue'

import { BankCellSkeleton } from '@/app/Content/states/IdleState/BankListState/BankCell'

import { Card } from '@/shared/ui/Card'
import { TheText } from '@/shared/ui/TheText'
import { Preloader } from '@/shared/ui/Preloader'

export default Vue.extend({
    name: 'Loader',
    setup() {
        const styles = useCssModule()

        return {
            styles,
        }
    },
    components: {
        Card,
        TheText,
        Preloader,
        BankCellSkeleton,
    },
})
</script>

<style module lang="scss" src="./Loader.module.scss" />
